import { AddBankDetails, AddSalary, AddSalaryRevision, Approve, Create, Delete, GenerateSalarySlip, Reject, Update, View } from "../Lib/constants";

const FeaturesList = {
    Create: Create,
    Update: Update,
    Delete: Delete,
    View: View,
    Approve: Approve,
    Reject: Reject,
    AddSalary: AddSalary,
    GenerateSalarySlip: GenerateSalarySlip,
    AddBankDetails: AddBankDetails,
    AddSalaryRevision: AddSalaryRevision,
}

export default FeaturesList;